<section class="content" style="margin-top: 0px">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
  <div class="content-block">
    <div class="block-header">
      <!-- breadcrumb -->
      <app-breadcrumb
        [title]="childLevelLabel"
        [items]="['Home', childLevelLabel]"
        [active_item]="childLevelLabel"
      >
      </app-breadcrumb>
    </div>
    <!-- Widgets -->
    <app-church-welcome-widget style="display: block; margin-bottom: 20px">
    </app-church-welcome-widget>

    <app-table
      *ngIf="!isLoading"
      [columns]="columns"
      [data]="data"
      [actions]="actions"
      [selectable]="true"
      [searchable]="true"
      [showAddButton]="true"
      [showDownload]="true"
      [showExcelDownload]="true"
      [showPdfDownload]="false"
      [addButtonText]="'Add ' + childLevelLabel"
      [addButtons]="addButtons"
      [searchPlaceholder]="'Search ' + childLevelLabel"
      (rowSelect)="onRowSelect($event)"
      (searchChange)="onSearch($event)"
      (refresh)="refresh()"
      (add)="addOutstation()"
      (downloadExcel)="downloadExcel()"
    ></app-table>
  </div>
</section>
